import request from '@/utils/request'

const coolerApi = {

  // 获取CoolerPlus SSO登录信息
  getCoolerPlusSsoInfo: () => {
    return request({
      url: '/cooler/sso/endpoint',
      method: 'get'
    })
  }

}
export default coolerApi
